module.exports = __webpack_public_path__ + "img/about_icone_2.4.13f75be3.webp";